import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormlyModule} from '@ngx-formly/core';
import {Validators} from '@angular/forms';
import {ZorrlyPlainWrapperComponent} from './wrappers/zorrly-plain-wrapper.component';
import {ZorrlyFormFieldWrapperComponent} from './wrappers/zorrly-form-field-wrapper.component';
import {ZorrlyInputComponent} from './types/zorrly-input.component';
import {ZorrlySelectComponent} from './types/zorrly-select.component';
import {ZorrlyDateComponent} from './types/zorrly-date.component';
import {ZorrlyTextareaComponent} from './types/zorrly-textarea.component';
import {ZorrlyInfoComponent} from './types/zorrly-info.component';
import {ZorrlyAgreeComponent} from './types/zorrly-agree.component';
import {ZorrlyDateTimeComponent} from './types/zorrly-datetime.component';
import {ZorrlyDateRangeComponent} from './types/zorrly-daterange.component';
import {ZorrlyCardWrapperComponent} from './wrappers/zorrly-card-wrapper.component';
import {defaultErrorMessages} from './errors';
import {accepted, noMissing} from './validators';
import {ZorrlyMultiSelectComponent} from './types/zorrly-multi-select.component';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    FormlyModule.forRoot({
        extras: {lazyRender: true},
        wrappers: [
          {name: 'card', component: ZorrlyCardWrapperComponent},
          {name: 'form-field', component: ZorrlyFormFieldWrapperComponent},
          {name: 'plain', component: ZorrlyPlainWrapperComponent},
        ],
        types: [
          {name: 'input', component: ZorrlyInputComponent, wrappers: ['form-field']},
          {name: 'number', extends: 'input', defaultOptions: {props: {type: 'number'}}},
          {name: 'select', component: ZorrlySelectComponent, wrappers: ['form-field']},
          {name: 'date-range', component: ZorrlyDateRangeComponent, wrappers: ['form-field']},
          {name: 'date', component: ZorrlyDateComponent, wrappers: ['form-field']},
          {name: 'datetime', component: ZorrlyDateTimeComponent, wrappers: ['form-field']},
          {name: 'textarea', component: ZorrlyTextareaComponent, wrappers: ['form-field']},
          {name: 'info', component: ZorrlyInfoComponent, wrappers: ['plain']},
          {name: 'agree', component: ZorrlyAgreeComponent, wrappers: ['plain']},
          {name: 'multi-select', component: ZorrlyMultiSelectComponent, wrappers: ['plain']},
          {name: 'description', extends: 'info'},
          {name: 'declaration', extends: 'agree'},
          {name: 'prefer-selects', extends: 'select'},
          {name: 'checkbox', extends: 'agree'},
        ],
        validators: [
          {name: 'email', validation: Validators.email},
          {name: 'accepted', validation: accepted()},
          {name: 'no-missing', validation: noMissing()},
        ],
        validationMessages: defaultErrorMessages,
      },
    ),
  ],
  exports: [
  ]
})
export class ZorrlyModule {
}
